/* eslint-disable */
export default {
  status: '狀態',
  acceptQueueCalls: '接受通話佇列電話',
  callQueueDisabledReason: '此設定由貴公司的管理員管理。',
  callQueueManagement: '管理佇列',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
